import {Component} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-timedout',
  imports: [MatButton, RouterLink],
  templateUrl: './timedout.component.html',
})
export class TimedoutComponent {}
